import {
  forwardRef,
  memo,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import useApiHttp from "../../hooks/use-http";
import { useNavigate, useParams } from "react-router-dom";
import decryptUrl from "../../util/img-decryption";
import {
  Checkbox,
  FormControlLabel,
  ImageList,
  ImageListItem,
} from "@mui/material";
import {
  ActionButton,
  Button,
  Container,
  Selectors,
  Text,
  DropdownMenuGroup,
  DropdownMenuItem,
  Notifications,
  AvatarV2,
  Spinner,
  Tooltip,
  InputCheckbox,
  Icon,
} from "@jds/core";
import PageLoader from "../../components/UI/Loader/PageLoader";
import Loader from "../../components/UI/Loader/Loader";
import JdsMenu from "../../components/UI/JdsMenu";
import { Menu } from "../../assets/svg/svg";
import brokenImg from "../../assets/png/brokenImg.png";
import { FileUploadContext } from "../../components/Layout/FileUploadLayout";
import { downloadFile, replaceMultipleSpaces } from "../../util/helper";
import EmptyState from "../../components/NoData/EmptyState";
import FsLightbox from "fslightbox-react";
import { useSelector } from "react-redux";
import { VirtuosoGrid } from "react-virtuoso";
import { LazyLoadImage } from "react-lazy-load-image-component";
import JdsModal from "../../components/UI/JdsModal";

const MenuButton = (props) => {
  return (
    <ActionButton
      icon={<Menu height="20px" width="20px" />}
      kind="tertiary"
      size="medium"
      {...props}
    />
  );
};
const PicOptionBtn = (props) => (
  <Button label="Picture Options" kind="secondary" size="small" {...props} />
);

const gridComponents = {
  List: forwardRef(({ style, children, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      style={{
        display: "flex",
        flexWrap: "wrap",
        ...style,
      }}
    >
      {children}
    </div>
  )),
  Item: ({ children, ...props }) => (
    <div
      {...props}
      style={{
        padding: "0.5rem",
        width: "200px",
        display: "flex",
        flex: "none",
        alignContent: "stretch",
        boxSizing: "border-box",
      }}
    >
      {children}
    </div>
  ),
};
const NewPhotos = () => {
  const { fid: folderId, id: eventId } = useParams();
  const navigate = useNavigate();
  const { handleFileUpload, handleFileDownloadOP } =
    useContext(FileUploadContext);
  const { photoUpload } = useSelector((state) => state.apiTrigger);
  const { eventDetails } = useSelector((state) => state.eventDetails);
  const { sendRequest: eventPhotosReq, isLoading: evenPhotosReqing } =
    useApiHttp();
  const { sendRequest: albumDetailReq, isLoading: albumDetailReqing } =
    useApiHttp();
  const { sendRequest: deleteImgReq, isLoading: deleteImgReqing } =
    useApiHttp();
  const { sendRequest: approvalReq, isLoading: approvalReqing } = useApiHttp();
  const { sendRequest: updataeWatermarkReq, isLoading: waterReqUpdating } =
    useApiHttp();
  const { sendRequest: getWatermarkReq, isLoading: waterReqGeting } =
    useApiHttp();
  const { sendRequest: getFrameReq, isLoading: frameReqGeting } = useApiHttp();
  const { sendRequest: updateFrameReq, isLoading: frameReqUpdating } =
    useApiHttp();
  const { sendRequest: downloadRequest } = useApiHttp();
  const [albumName, setAlbumName] = useState("");
  const [lastPage, setLastPage] = useState(0);
  const [page, setPage] = useState(0);
  const [photosList, setPhotosList] = useState([]);
  const [previewImgArr, setPreviewImgArr] = useState([]);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [photosCount, setPhotosCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [check, setCheck] = useState([]);
  const [selectedTab, setSelectedTab] = useState("event");
  const [deleteCount, setDeleteCount] = useState(0);
  const [deleteConfirmation, setDeleteConfirmation] = useState(true);
  const [watermarkStatus, setWatermarkStatus] = useState(false);
  const [frameData, setFrameData] = useState(null);
  const [frameStatus, setFrameStatus] = useState(false);
  const fileInputRef = useRef();
  const openLightboxOnSlide = (number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  };

  const controller = new AbortController();

  const getEventPhotos = (page, selectedTab) => {
    eventPhotosReq(
      {
        url:
          selectedTab === "event"
            ? `images?eventId=${eventId}&folderId=${folderId}&page=${page}&size=50`
            : selectedTab === "guest"
              ? `guest-images?eventId=${eventId}&folderId=${folderId}&isPublic=false&page=${page}&size=50`
              : `guest-images?eventId=${eventId}&folderId=${folderId}&isPublic=true&page=${page}&size=50`,
        method: "GET",
        base: "MEDIA",
        signal: controller.signal,
      },
      null,
      (data) => {
        setPhotosCount(data?.count);
        setDeleteCount(0);
        setLastPage(data?.lastPage);
        if (page == 0) {
          setPhotosList(data?.data);
          setCheck(Array(data?.data.length).fill(false));
        } else {
          setPhotosList((pre) => [...pre, ...data?.data]);
          if (selectAll) {
            setCheck((pre) => [...pre, ...Array(data?.data.length).fill(true)]);
            const ids = data?.data?.map((item) => item.id);
            setSelectedId((pre) => [...pre, ...ids]);
          } else {
            setCheck((pre) => [
              ...pre,
              ...Array(data?.data.length).fill(false),
            ]);
          }
        }
      }
    );
  };
  const downloadHande = (mediaId) => {
    const formData = new FormData();
    formData.append("mediaId", mediaId);
    formData.append("eventId", eventId);

    downloadRequest(
      {
        url: `frame/download`,
        method: "POST",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        const imageUrl = URL.createObjectURL(data);
        downloadFile(imageUrl, "image");
      },
      (err, data) => {
        Notifications.toast.error({
          id: "download-photos-error",
          title: data?.message,
        });
      }
    );
  };
  const handleSelectAllChange = (e) => {
    setSelectAll(e.target.checked); // Update checkboxes state
    setCheck((prev) => Array(prev.length).fill(e.target.checked));

    // Update selected IDs
    if (e.target.checked) {
      const ids = photosList.map((item) => item.id);
      setSelectedId(ids);
    } else {
      setSelectedId([]);
    }
  };
  const handleCheckboxChange = useCallback((checked, index, id) => {
    setCheck((prev) => {
      const newCheck = [...prev];
      newCheck[index] = checked; // Update the checkbox state
      return newCheck; // Return the new array
    });
    if (checked) {
      setSelectedId((pre) => [...pre, id]);
    } else {
      setSelectedId((pre) => pre.filter((item) => item !== id));
      setSelectAll(false);
    }
  }, []);
  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (evenPhotosReqing) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [evenPhotosReqing, lastPage]
  );

  // Action services
  const deleteImage = () => {
    const deleteIds = selectedId;

    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("mediaIDs", deleteIds);
    deleteImgReq(
      {
        url: `image/delete`,
        method: "DELETE",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "delete-photos",
          tilte: data.message,
        });
        const pLength = photosList.length;
        setCheck(Array(pLength - deleteIds.length).fill(false));
        setPhotosList((pre) =>
          pre.filter((item) => !deleteIds.includes(item.id))
        );
        setDeleteCount(deleteCount + deleteIds.length);
        setSelectedId([]);
      },
      (err, data) =>
        Notifications.toast.error({ id: "delete-photos", tilte: data.message })
    );
  };

  const approvePhoto = (status) => {
    console.log("test1234");
    const mediaIds = selectedId;
    const formData = new FormData();

    formData.append("mediaIDs", mediaIds);
    formData.append("status", status);
    formData.append("eventId", eventId);

    approvalReq(
      {
        url: "set-multiple-media-privacy",
        base: "MEDIA",
        method: "PUT",
        body: formData,
        formData: true,
      },
      null,
      (data) => {
        // setPhotosList((pre) =>
        //   pre.map((item) =>
        //     !mediaIds.includes(item.id) ? item : { ...item, isPublic: status }
        //   )
        // );
        Notifications.toast.success({
          id: "approve-photos",
          tilte: data.message,
        });
        const pLength = photosList.length;
        setCheck(Array(pLength - mediaIds.length).fill(false));
        setPhotosList((pre) =>
          pre.filter((item) => !mediaIds.includes(item.id))
        );
        setDeleteCount(deleteCount + mediaIds.length);
        setSelectedId([]);
      },
      (err, data) =>
        Notifications.toast.error({ id: "approve-photos", tilte: data.message })
    );
  };
  const getWatermarkDetails = () => {
    getWatermarkReq(
      {
        url: `watermark/event/${eventId}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        console.log("data", data);
        setWatermarkStatus(data?.data?.isActive);
      },
      (err, data) => {
        console.log("Error", data);
      }
    );
  };

  const updateWatermark = (status) => {
    const formData = new FormData();
    formData.append("isActive", status);
    updataeWatermarkReq(
      {
        url: `watermark/event/${eventId}`,
        method: "PATCH",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        getWatermarkDetails();
      },
      (err, data) => { }
    );
  };
  const getFrameDetails = () => {
    getFrameReq(
      {
        url: `frame/frame-details?eventId=${eventId}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFrameStatus(data?.data?.frameStatus);
        if (data?.data?.frameStatus) {
          setFrameData(data?.data);
        } else {
          setFrameData(null);
        }
      },
      (err, data) => {
        console.log("Error", data);
      }
    );
  };
  const updateFrame = (status) => {
    const formData = new FormData();
    formData.append("frameStatus", status);
    formData.append("downloadStatus", false);
    formData.append("eventId", eventId);
    updateFrameReq(
      {
        url: `frame/set-frame-status`,
        method: "PUT",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        getFrameDetails();
      },
      (err, data) => {
        Notifications.toast.error({
          id: "update-frame",
          title: data?.message,
        });
      }
    );
  };
  useEffect(() => {
    getEventPhotos(page, selectedTab);
    return () => {
      controller.abort();
    };
  }, [page, selectedTab]);
  useEffect(() => {
    setPreviewImgArr(
      photosList.map((item) => (
        <div style={{ position: "relative" }}>
          <img
            src={decryptUrl(item?.reducedFileSignedPath)}
            style={{ width: "100%", height: "100%" }}
          />
          {frameData?.frameStatus && (
            <img
              src={
                item.orientation == "landscape"
                  ? decryptUrl(frameData?.landscapeFrame)
                  : decryptUrl(frameData?.portraitFrame)
              }
              className="frame"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                objectFit: "fill",
              }}
            />
          )}
        </div>
      ))
    );
  }, [photosList, frameData]);
  // useEffect(() => {

  // }, [selectedTab]);
  useEffect(() => {
    if (selectedId.length === photosList.length && selectedId.length !== 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedId]);

  useEffect(() => {
    if (
      photoUpload[eventId + folderId] &&
      selectedTab !== "guest" &&
      selectedTab !== "approved"
    ) {
      setPhotosList([]);
      if (page !== 0) {
        setPage(0);
      } else {
        getEventPhotos(0, "event");
      }
    }
  }, [photoUpload]);

  useEffect(() => {
    albumDetailReq(
      {
        url: `event-folders/getfolder?eventId=${eventId}&folderId=${folderId}`,
      },
      null,
      (data) => setAlbumName(data?.data?.name)
    );
    getFrameDetails();
    getWatermarkDetails();
  }, []);

  return (
    <>
      <input
        type="file"
        accept=".png, .jpg, .jpeg"
        id="banner-file__upload"
        // onChange={handleFileChange}
        onChange={(e) => {
          const files = [...e.target.files];
          handleFileUpload(files, eventId, folderId, albumName);
        }}
        style={{ display: "none" }}
        ref={fileInputRef}
        multiple
      />

      <div
        style={{
          position: "sticky",
          top: "112px",
          zIndex: 30,
          backgroundColor: "white",
          paddingTop: "48px",
          transform: "translateY(-40px)",
          // paddingBottom: "px",
        }}
      >
        <Container horizontalAlign="space-between" fullWidth>
          <Container direction="column" gap={8}>
            {/* <div
              onClick={() => navigate(-1)}
              style={{
                cursor: "pointer",
                display: "flex",
                marginBottom: "16px",
              }}
            >
              <Icon ic={"IcChevronLeft"} color="primary_60" />
              <Text text="Back" appearance="body_s_bold" color="primary_60" />
            </div> */}

            <div
              style={{
                display: "flex",
                marginBottom: "16px",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Icon
                ic={"IcBack"}
                color="primary_60"
                onClick={() => navigate(-1)}
              />
              <Text text="Albums" appearance="heading-xs" />
            </div>

            <Text
              text={`${albumName || ""} - ${photosCount - deleteCount || 0} ${photosCount - deleteCount > 1 ? "Photos" : "Photo"
                }`}
              appearance="body-m"
              color="primary-grey-80"
            />
          </Container>
          <Container gap={8}>
            {selectedId.length == 0 && (
              <ActionButton
                label="Upload"
                kind="secondary"
                size="medium"
                icon="IcUpload"
                onClick={() => {
                  if (fileInputRef.current) {
                    fileInputRef.current.value = null; // Reset file input
                  }
                  if (fileInputRef.current) {
                    fileInputRef.current.click(); // Open file dialog
                  }
                }}
                appearance=""
              />
            )}
            {selectedId.length !== 0 && (
              <ActionButton
                icon={"IcDownload"}
                label="Download"
                onClick={() => {
                  if (selectedId.length > 1) {
                    handleFileDownloadOP(selectedId, eventId);
                    setSelectedId([]);
                    setCheck((pre) => Array(pre.length).fill(false));
                  }
                  if (selectedId.length == 1) {
                    downloadHande(selectedId);
                    setSelectedId([]);
                    setCheck((pre) => Array(pre.length).fill(false));
                  }
                }}
              />
            )}
          </Container>
        </Container>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <div style={{ width: "650px" }}>
            <Selectors
              stretch
              selectedIndex={
                selectedTab === "event" ? 0 : selectedTab === "guest" ? 1 : 2
              }
              onChange={(val) => {
                setSelectedTab(val);
                setPage(0);
                setPhotosList([]);
                setCheck([]);
                setSelectedId([]);
                setSelectAll(false);
              }}
              items={[
                {
                  label: "Event Photos",
                  value: "event",
                },
                {
                  label: "Guest Uploaded Photos",
                  value: "guest",
                },
                {
                  label: "Guest Approved Photos",
                  value: "approved",
                },
              ]}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginTop: "12px",
          }}
        >
          {selectedId.length > 0 && (
            <div>
              <ActionButton
                label={`Selected ${selectAll ? photosCount - deleteCount : selectedId.length
                  }`}
                icon={"IcClose"}
                iconPosition="right"
                kind="secondary"
                size="small"
                onClick={() => {
                  setSelectedId([]);
                  setCheck((pre) => Array(pre.length).fill(false));
                }}
              />
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              label="Select All"
              control={
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                />
              }
            />
            {/* {eventDetails?.userRole == "ADMIN" && (
              <Container>
                <JdsMenu
                  trigger={{ component: PicOptionBtn }}
                  onSelect={(value) => {}}
                >
                  <DropdownMenuGroup hideBottomDivider>
                    <DropdownMenuItem
                      value="watermark"
                      prefix={
                        watermarkStatus ? "IcCheckboxOn" : "IcCheckboxOff"
                      }
                      label="Watermark"
                      onClick={() => {
                        updateWatermark(!watermarkStatus);
                      }}
                    />
                    <DropdownMenuItem
                      value="frame"
                      prefix={frameStatus ? "IcCheckboxOn" : "IcCheckboxOff"}
                      label="Frame"
                      onClick={() => {
                        updateFrame(!frameStatus);
                      }}
                    />
                  </DropdownMenuGroup>
                </JdsMenu>
              </Container>
            )} */}
          </div>
          {selectedId.length > 0 && (
            <JdsMenu
              trigger={{
                component: MenuButton,
                componentProps: {
                  style: {
                    marginTop: "3px",
                  },
                },
              }}
            >
              <DropdownMenuGroup hideBottomDivider>
                {selectedTab === "guest" && (
                  <DropdownMenuItem
                    prefix={"IcPhoto"}
                    label="Approve Photo"
                    value="approve"
                    onClick={() => approvePhoto(true)}
                  />
                )}
                {selectedTab === "approved" && (
                  <DropdownMenuItem
                    prefix={"IcError"}
                    label="Disapprove Photo"
                    value="disapprove"
                    onClick={() => approvePhoto(false)}
                  />
                )}
                <DropdownMenuItem
                  prefix={"IcTrash"}
                  label="Delete"
                  value="delete"
                  onClick={() => {
                    // deleteImage();
                    setDeleteConfirmation(false);
                  }}
                />

                {/* <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" /> */}
              </DropdownMenuGroup>
            </JdsMenu>
          )}
        </div>
        <JdsModal
          header={
            <Text
              text="Are you sure you want to delete?"
              appearance="body_m_bold"
            />
          }
          size="m"
          kind="dialog"
          close={deleteConfirmation}
          onClose={() => {
            setDeleteConfirmation(true);
          }}
          primaryCTA={{
            title: "Yes",
          }}
          secondaryCTA={{
            title: "No",
          }}
          onPrimaryClick={() => {
            deleteImage();
            setDeleteConfirmation(true);
          }}
          onSecondaryClick={() => setDeleteConfirmation(true)}
        ></JdsModal>
      </div>

      {page === 0 && evenPhotosReqing && (
        <Container
          fullWidth
          horizontalAlign="center"
          verticalAlign="center"
          style={{ minHeight: "220px" }}
        >
          <Spinner kind="primary" label="Loading..." size="large" />
        </Container>
      )}

      {photosList.length == 0 && !evenPhotosReqing && (
        <EmptyState
          title="No Photos"
          subtitle=""
          action={false}
          style={{ marginTop: "32px" }}
        />
      )}

      {photosList.length !== 0 && (
        <VirtuosoGrid
          style={{
            height: "calc(100vh - 356px)",
          }}
          className="custom-scrollbar"
          data={photosList}
          components={gridComponents}
          itemContent={(i, item) => (
            <EventPhotoCard
              {...item}
              handleCheckboxChange={handleCheckboxChange}
              index={i}
              check={check[i]}
              selectedTab={selectedTab}
              lastElementRef={
                i + 1 === photosList.length ? lastElementRef : null
              }
              frameStatus={frameStatus}
              frameData={frameData}
              openLightboxOnSlide={openLightboxOnSlide}
            />
          )}
        />
      )}
      {page !== 0 && evenPhotosReqing && (
        <Loader
          size="small"
          containerProps={{ style: { marginTop: "16px" } }}
        />
      )}
      {(deleteImgReqing || approvalReqing) && (
        <PageLoader
          open={deleteImgReqing || approvalReqing}
          label={
            deleteImgReqing || (approvalReqing && "Please wait for a while...")
          }
        />
      )}

      {previewImgArr.length ? (
        <FsLightbox
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
        // disableLocalStorage={true}
        />
      ) : null}
    </>
  );
};
export default NewPhotos;

const EventPhotoCard = memo(
  ({
    thumbnailFileSignedPath,
    reducedFileSignedPath,
    id,
    handleCheckboxChange,
    index,
    check,
    isPublic,
    userName,
    selectedTab,
    frameStatus,
    frameData,
    openLightboxOnSlide,
    lastElementRef,
  }) => {
    const { fid: folderId, id: eventId } = useParams();
    const decryptPath = decryptUrl(thumbnailFileSignedPath);
    const { sendRequest: thumbnailRequest, isLoading: isThumbnailRequest } =
      useApiHttp();
    const thumbnailUpdate = (thumbnail) => {
      thumbnailRequest(
        {
          url: `event/update-thumbnail`,
          method: "PUT",
          body: {
            eventId,
            folderId,
            thumbnail,
          },
          // formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "upload-thumbnail",
            title: data?.message,
          });
        },
        (err, data) => {
          Notifications.toast.error({
            id: "upload-thumbnail",
            title: data?.message,
          });
        }
      );
    };
    const [errorImg, setErrorImg] = useState(false);
    return (
      <div
        className="photos-card"
        style={{
          width: "184px",
          height: "184px",
          overflow: "hidden",
          borderRadius: "24px",
          position: "relative",
        }}
        onClick={() => {
          openLightboxOnSlide(index + 1);
        }}
        ref={lastElementRef}
      >
        <div className="frame-container">
          {/* <img
            src={decryptPath}
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              display: "block",
            }}
          /> */}
          <LazyLoadImage
            alt="face"
            effect="blur"
            src={errorImg ? brokenImg : decryptPath}
            style={{
              objectFit: "cover",
              width: "184px",
              height: "184px",
              borderRadius: "24px",
            }}
            onError={() => {
              setErrorImg(true);
            }}
          />
          {frameStatus && (
            <img
              src={decryptUrl(frameData?.portraitFrame) || ""}
              alt="frame-img"
              className="frame"
            />
          )}
        </div>

        <Container
          style={{
            position: "absolute",
            top: 0,
            left: "0",
            width: "100%",
            height: "100%",
          }}
        >
          {(selectedTab === "guest" || isPublic) && (
            <Container style={{ marginTop: "15px", paddingLeft: "15px" }}>
              <AvatarV2
                initials={replaceMultipleSpaces(userName) || ""}
                avatarKind="initials"
                kind={isPublic ? "status" : "default"}
                size="small"
                statusBadgeKind="icon"
                statusBadgeStatus="success"
              />
            </Container>
          )}
        </Container>
        <div
          className={`card-select-overlay ${check ? "card-select-overlay-view" : ""
            }`}
          onClick={() => {
            // openLightboxOnSlide(index + 1);
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              marginTop: "15px",
              padding: "0 15px",
            }}
          >
            {(selectedTab === "guest" || isPublic) && (
              <Tooltip
                label={replaceMultipleSpaces(userName)}
                position="bottom"
              >
                <AvatarV2
                  initials={replaceMultipleSpaces(userName) || ""}
                  avatarKind="initials"
                  kind={isPublic ? "status" : "default"}
                  size="small"
                  statusBadgeKind="icon"
                  statusBadgeStatus="success"
                />
              </Tooltip>
            )}
            <div></div>
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <InputCheckbox
                checked={check}
                onChange={(e) =>
                  handleCheckboxChange(e.target.checked, index, id)
                }
              />
            </div>
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              left: "22px",
              width: "100%",
              margin: "auto",
            }}
            className="card-btn"
            onClick={(e) => {
              e.stopPropagation();
              thumbnailUpdate(decryptUrl(reducedFileSignedPath));
            }}
          >
            <Button
              label="Set Thumbnail"
              kind={frameStatus ? "primary" : "secondary"}
              size="small"
              appearance=""
              onClick={() => { }}
            />
          </div>
        </div>
      </div>
    );
  }
);
